var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Slider from 'rc-slider';
import Tracking from './Tracking';
import { connect } from 'react-redux';
import CardContent from 'material-ui/Card/CardContent';
import Grid from 'material-ui/Grid';
import Switch from 'material-ui/Switch';
import { sendUpdateMessage } from '../../websocket';
import TestModeDependentContainer from '../../containers/TestModeDependentContainer';
import { OffsetMultiplier } from './OffsetMultiplier';
import ScenarioProgressBar from './ScenarioProgressBar';
function meterPerSec2KmPerHour(kmPerHour) {
    return kmPerHour * 3.6;
}
var VehicleControllerRaw = /** @class */ (function (_super) {
    __extends(VehicleControllerRaw, _super);
    function VehicleControllerRaw() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeSpeed = function (value) {
            _this.props.dispatch({
                type: 'MAXIMUM_SPEED_CHANGE',
                value: value,
            });
        };
        _this.changeAutoStart = function (_, value) {
            _this.props.dispatch(sendUpdateMessage('autoStop', value));
        };
        return _this;
    }
    VehicleControllerRaw.prototype.render = function () {
        return (React.createElement(CardContent, { style: { padding: '12px 16px' } },
            React.createElement(Grid, { container: true, alignItems: "center" },
                React.createElement(Grid, { item: true, xs: 12, md: 12 },
                    React.createElement(TestModeDependentContainer, { referenceMode: "test_scenario" },
                        React.createElement(Tracking, { playMessageName: "scenarioPlay", skipMessageName: "scenarioSkip", playing: this.props.scenarioPlay, disabled: !this.props.scenario, skipValue: 30000 }),
                        React.createElement(ScenarioProgressBar, null)),
                    React.createElement(TestModeDependentContainer, { referenceMode: "automated" },
                        React.createElement(Tracking, { playMessageName: "play", skipMessageName: "skip", playing: this.props.playing, disabled: false, skipValue: 1 }))),
                React.createElement(Grid, { item: true, xs: 12, md: 3 },
                    React.createElement("span", null, "Actual speed")),
                React.createElement(Grid, { item: true, xs: 12, md: 9 },
                    React.createElement("span", null,
                        React.createElement("strong", null,
                            Math.round(meterPerSec2KmPerHour(this.props.actualSpeed)),
                            " km/h"))),
                React.createElement(TestModeDependentContainer, { referenceMode: "test_scenario" },
                    React.createElement(OffsetMultiplier, null)),
                React.createElement(TestModeDependentContainer, { referenceMode: "automated" },
                    React.createElement(Grid, { item: true, xs: 12, md: 3 },
                        React.createElement("span", null, "Maximum speed")),
                    React.createElement(Grid, { item: true, xs: 12, md: 6 },
                        React.createElement(Slider, { value: this.props.maximumSpeed, onChange: this.changeSpeed })),
                    React.createElement(Grid, { item: true, xs: 12, md: 3, style: { textAlign: 'center' } },
                        React.createElement("span", null,
                            "\u00A0",
                            this.props.maximumSpeed,
                            " km/h")),
                    React.createElement(Grid, { item: true, xs: 12, md: 3 },
                        React.createElement("span", null, "Auto start/stop")),
                    React.createElement(Grid, { item: true, xs: 12, md: 9 },
                        React.createElement(Switch, { checked: this.props.autoStop, onChange: this.changeAutoStart, color: "primary", style: { margin: '-14px 0' } }))))));
    };
    return VehicleControllerRaw;
}(React.Component));
export var VehicleController = connect(function (state) { return ({
    actualSpeed: state.actualSpeed,
    autoStop: state.autoStop,
    maximumSpeed: state.maximumSpeed,
    scenarioPlay: state.scenarioPlay,
    playing: state.playing,
    scenario: state.scenario,
}); })(VehicleControllerRaw);



//////////////////
// WEBPACK FOOTER
// ./src/components/VehicleController/index.tsx
// module id = 1776
// module chunks = 0